module.exports = __webpack_public_path__ + "media/images/hero-87d06e61a386e91f08e7875709be7cdd.jpeg";